import UniqueItem from "./UniqueItem";

class ArticleLink extends UniqueItem {
    constructor(jsonData){
        super(jsonData);
        this.ui = jsonData.ui;
        this.title = jsonData.title;
        this.contentUrl = jsonData.links[0].url;
        this.logUrl = jsonData.links[0].log_url;
    }
}

export default ArticleLink;



// WEBPACK FOOTER //
// ./src/models/ArticleLink.js